<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="page_title">About page</div>
        <div>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad fugiat vero ratione dolorem facere autem repellat architecto rerum harum cumque deserunt dolores enim, excepturi, accusamus facilis natus necessitatibus sed? Culpa velit deserunt quas a ex quisquam illum quos, optio alias iste commodi. Distinctio quibusdam veniam voluptates esse tempora libero autem, iusto atque impedit eius pariatur inventore suscipit quasi amet ad! Officia eligendi, praesentium sint veniam placeat aliquid iure maxime magni eius repudiandae harum corporis maiores quam nesciunt dolores ratione minus quo nulla nostrum id, in perspiciatis dolore, incidunt ipsam! Atque eaque aliquam odio rem aut, non possimus harum veritatis reiciendis!<br><br>
            <ul>
                <li>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus natus numquam quas maxime quia delectus qui ducimus deserunt eveniet quo!
                </li>
                <li>
                    Lorem, ipsum.
                </li>
                <li>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quasi, nisi.
                </li>
            </ul>
            <div>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quia facilis id voluptates vero, maiores rem. Provident id praesentium dolorum recusandae iste quas laudantium. Necessitatibus, fugit laborum ducimus repellendus tenetur laboriosam reprehenderit neque voluptate optio accusantium dolorum unde? Placeat ullam assumenda veniam voluptates quo sequi non hic tempore tempora minima! Iusto laudantium tempore nobis neque ut. Voluptatum pariatur mollitia esse dolorem illum animi consequatur recusandae nihil cupiditate eveniet beatae est voluptates ad eligendi placeat, praesentium dolor, deleniti rem velit? Officia deserunt quasi amet a enim aliquam voluptatibus ex dicta facere, tenetur est in architecto consectetur delectus rem, optio quisquam, nobis quis!
            </div>
        </div>
    </div>
</template>


<script>
    import {

    } from 'vue';

    import {
        addIcons
    } from 'ionicons'
    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })
    import {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
    } from '@ionic/vue';

    import {
        useRouter,
    } from 'vue-router'


    export default {
        components: {
            IonToolbar,
            IonButton,
            IonButtons,
            IonIcon,
        },
        directives: {

        },
        setup() {
            const $router = useRouter()


            const goBack = () => {
                $router.push({
                    name: 'common_about'
                })
            };

            return {
                goBack,
            }
        },
    }
</script>